import React from 'react'
import Image from "../../../elements/Image";

const PageBanner = ({ title, image }) => {
  return (
    <>
      <section className="relative flex w-full h-[400px] xls:h-[600px] overflow-hidden items-center pt-12">
        <div className="absolute w-full h-full left-0 top-0 flex after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:bg-chestnut-rose after:opacity-30">
          {image && (
            <Image
              src={image}
              alt={title || image}
              effect={'fade'}
              classes={"object-cover"}
            />
          )}
        </div>
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="relative w-full max-w-5xl mx-auto">
            {title && (
              <h1 className="text-4xl md:text-6xl xls:text-[66px] font-bold text-white text-center !leading-normal">{title}</h1>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default PageBanner;